module.exports = __webpack_public_path__ + "static/media/planeIcon.9b11e386.png";